export default __webpack_public_path__ + "static/media/Evento.55e179bf.png";